/**
 * Dernier garage ouvert dans cet onglet, et à quel titre (membre ou session support). Mémoire de
 * l'onglet (`sessionStorage`) : elle survit au rechargement, jamais partagée avec un autre onglet ni
 * envoyée au serveur. Elle permet de dire « Votre accès à ce garage a été retiré » (C1) ou
 * « L'accès support a pris fin » (A1) au lieu de « Garage introuvable », sans rien révéler de plus
 * que ce que l'onglet a déjà vu.
 */
export interface LastAccess {
  slug: string;
  support: boolean;
}

const KEY = 'garage.lastAccess';

export function readLastAccess(): LastAccess | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<LastAccess>;
    return typeof v.slug === 'string' && typeof v.support === 'boolean' ? { slug: v.slug, support: v.support } : null;
  } catch {
    return null;
  }
}

export function writeLastAccess(v: LastAccess): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(v));
  } catch {
    // Stockage indisponible (navigation privée stricte) : on retombe sur « Garage introuvable ».
  }
}

export function clearLastAccess(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // idem
  }
}
